import angular from 'angular'
import _ from 'lodash'

class RelatedDocuments {
  constructor(metaData, label, form, urlKey, docType, config) {
    this.metaData = metaData
    this.label = label
    this.form = form
    this.urlKey = urlKey
    this.docType = docType
    this.attachmentUrl = (docType == 'occ-drilling' ?
      config.drillingAttachmentEndpoint :
      config.appOrderAttachmentEndpoint
      ) + urlKey + '/file/' + label
  }

  static fromJson(relatedDocuments, config) {
    return new RelatedDocuments(
     relatedDocuments.metaData,
     relatedDocuments.label,
     relatedDocuments.form,
     relatedDocuments.urlKey,
     relatedDocuments.docType,
     config
    )
  }

  static fromJsonArray(records, config) {
    return _.map(
      records,
      record => RelatedDocuments.fromJson(record, config)
    )
  }

  static instantiateRelatedDocuments(data, headers) {
    var response
    try {
      response = angular.fromJson(data)
      response = RelatedDocuments.fromJsonArray(response, this.config)
    } catch (e) {
      response = data
    }

    return response
  }

  static factory($resource, $log, config) {
    this.config = config
    return $resource(
      config.attachmentsEndpoint + '/:dest' + '/:id',
      {},
      {
        queryOkDrilling: {
          method:'GET',
          isArray: true,
          params: {
            dest: config.drillingAttachmentKey,
            id: '@id'
          },
          transformResponse: RelatedDocuments.instantiateRelatedDocuments.bind(this)
        },
        queryOkAppOrders: {
          method:'GET',
          isArray: true,
          params: {
            dest: config.appOrderAttachmentKey,
            id: '@id'
          },
          transformResponse: RelatedDocuments.instantiateRelatedDocuments.bind(this)
        }
      }
    )
  }
}

RelatedDocuments.factory.$inject = ['$resource', '$log', 'config']

export default RelatedDocuments
